/**
 * Digits with the usual separators and an optional leading plus. Deliberately loose — formats vary
 * per country — and the same pattern the server enforces, so the form refuses exactly what the
 * server would.
 */
const PHONE_PATTERN = /^\+?[0-9 ()\-./]{6,30}$/;

/** Sorts after any real number when ascending; digits never reach this code point. */
const NO_PHONE_SORT_KEY = '￿';

export const isValidPhoneNumber = (value: string | undefined): boolean => PHONE_PATTERN.test((value ?? '').trim());

/**
 * What the phone column sorts on. Separators are dropped so "020-123" and "(020) 123" sort
 * together, and a leading `+` is read as the `00` it dials as, so international numbers group
 * together rather than before every national one. Blanks sort last.
 */
export const phoneSortValue = (value: string | undefined): string => {
  const trimmed = (value ?? '').trim();

  if (trimmed === '') {
    return NO_PHONE_SORT_KEY;
  }

  const digits = trimmed.replace(/\D/g, '');
  return trimmed.startsWith('+') ? `00${digits}` : digits;
};

/** A `tel:` URI holding only what a dialler reads: digits and a leading `+`. */
export const telHref = (value: string): string => {
  const trimmed = value.trim();
  return `tel:${trimmed.startsWith('+') ? '+' : ''}${trimmed.replace(/\D/g, '')}`;
};

export default isValidPhoneNumber;
